import window from 'global/window';
// import {currentPortalPages} from '@netx/core-cms/singletons/currentPortalPages';
import {type IBrandPortalAction} from '../schema';

export const getPortalPageSlugFromPortalAction = (
	action: IBrandPortalAction,
) => {
	const pageId = parseInt(action.goo.link.replace('#page/', ''));
	const page = window.Netx.cms.pages?.find((page: any) => page.id === pageId);
	return page?.get('slug');
};
